import { render, staticRenderFns } from "./boxDashboard.vue?vue&type=template&id=25ad05a8&scoped=true&"
import script from "./boxDashboard.vue?vue&type=script&lang=js&"
export * from "./boxDashboard.vue?vue&type=script&lang=js&"
import style0 from "./boxDashboard.vue?vue&type=style&index=0&id=25ad05a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ad05a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VIcon})
